module.exports = __webpack_public_path__ + "static/WEDDING E&M-456-a9448c6613f0fb2c8d69d3194621bb5a.jpg";